




















































import { Component, Vue } from 'vue-property-decorator'
import ImportItems from './settings/ImportItems.vue'
import SelectBlips from './settings/SelectBlips.vue'

@Component({
  components: {
    ImportItems,
    SelectBlips
  }
})
export default class Settings extends Vue {
  public stepperCount: number = 1
  public stepperComplete: number = 0
  get canProgress (): boolean {
    return this.stepperComplete >= this.stepperCount
  }

  public isComplete (step: number, value: boolean) {
    if (step === this.stepperCount) {
      if (value) {
        this.stepperComplete = step
      } else {
        this.stepperComplete = step - 1
      }
    }
  }
}
